import { render } from "./QuestionsCard.vue?vue&type=template&id=16c79746&scoped=true"
import script from "./QuestionsCard.vue?vue&type=script&lang=js"
export * from "./QuestionsCard.vue?vue&type=script&lang=js"

import "./QuestionsCard.vue?vue&type=style&index=0&id=16c79746&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c79746"]])

export default __exports__